;(function () {
  angular
    .module('contrast.avatar')
    .controller('avatarPickerCtrl', avatarPickerCtrl)

  function avatarPickerCtrl($scope, $uibModalInstance, logger, CAT_AVATARS) {
    'ngInject'

    var vm = this,
      uploadedImage = false

    angular.extend(vm, {
      catAvatars: CAT_AVATARS,
      selectedCat: null,
      croppedSelected: false
    })

    angular.extend(vm, {
      onUpload: onUpload,
      onCrop: onCrop,
      onError: onError,
      close: close,
      done: done,
      selectCat: selectCat
    })

    function onUpload() {
      uploadedImage = true
      vm.selectedCat = null
      vm.croppedSelected = true
      $scope.$apply()
    }

    function onCrop(image) {
      if (!vm.selectedCat) {
        $uibModalInstance.close(image)
      }
    }

    function onError(title, contents) {
      logger.logError(title)
      logger.logError(contents)
    }

    function close() {
      $uibModalInstance.dismiss('cancel')
    }

    function done() {
      if (vm.selectedCat) {
        $uibModalInstance.close('images/cats/' + vm.selectedCat)
      }
    }

    function selectCat(cat) {
      if (vm.selectedCat == cat) {
        vm.selectedCat = null
        vm.croppedSelected = uploadedImage
      } else {
        vm.selectedCat = cat
        vm.croppedSelected = false
      }
    }
  }
})()
